import { type AircraftMaintenanceLimitExtension } from '../../../Admin/AircraftMaintenanceLimitExtensions/AircraftMaintenanceLimitExtension';
import {
    aircraftMaintenanceLimitExtensionFromDb,
    aircraftMaintenanceLimitExtensionToDb,
} from '../../../Admin/AircraftMaintenanceLimitExtensions/AircraftMaintenanceLimitExtension';
import { aircraftMaintenanceLimitExtensionItemFields } from '../../../Admin/Datasources/AircraftMaintenanceLimitExtensions';
import { type DbSyncerUpDefinition } from '../syncHelpers';
import { getStandardSyncerFields } from '../syncHelpers';

let counter = 0;

export const aircraftMaintenanceLimitExtensionSyncerDefinition: DbSyncerUpDefinition = (
    record: AircraftMaintenanceLimitExtension
) => {
    const c = ++counter;
    const [commandName, inputType] = record._version
        ? ['updateAircraftMaintenanceLimitExtension', 'UpdateAircraftMaintenanceLimitExtensionInput']
        : ['createAircraftMaintenanceLimitExtension', 'CreateAircraftMaintenanceLimitExtensionInput'];
    const { mutationName, inputKey, query } = getStandardSyncerFields(
        commandName,
        c,
        aircraftMaintenanceLimitExtensionItemFields
    );
    const input = aircraftMaintenanceLimitExtensionToDb(record);
    return {
        query,
        input,
        inputKey,
        inputType,
        mutationName,
        remoteToLocalTransform: aircraftMaintenanceLimitExtensionFromDb,
        queryName: 'getAircraftMaintenanceLimitExtension',
    };
};
